import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { InputNumberModule } from 'primeng/inputnumber';
import { SkeletonModule } from 'primeng/skeleton';
import { FacilityWithLevels, ProductCurrentLevels, ProductWithLevels } from '../../../user-management.model';

@Component({
  selector: 'app-permissions',
  imports: [AccordionModule, InputNumberModule, FormsModule, SkeletonModule],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionsComponent {
  @Input() facilities: FacilityWithLevels[] = [];
  @Input() isLoading = false;
  @Output() facilitiesChange = new EventEmitter<FacilityWithLevels[]>();
  @Output() validityChange = new EventEmitter<boolean>();

  readonly columns: (keyof ProductCurrentLevels)[] = ['Technical', 'Pricing'];

  // Tracks invalid inputs keyed as "facilityName|productId|type"
  invalidInputs = new Set<string>();

  isInvalid(facilityName: string, productId: string, type: keyof ProductCurrentLevels): boolean {
    return this.invalidInputs.has(`${facilityName}|${productId}|${type}`);
  }

  onLevelChange(facilityName: string, productId: string, type: keyof ProductCurrentLevels, value: number): void {
    const key = `${facilityName}|${productId}|${type}`;

    if (value === null || value === undefined || isNaN(value)) {
      this.invalidInputs.add(key);
    } else {
      this.invalidInputs.delete(key);
    }

    this.validityChange.emit(this.invalidInputs.size === 0);
    if (this.invalidInputs.has(key)) return;

    const updated: FacilityWithLevels[] = structuredClone(this.facilities);
    const facility = updated.find((f) => f.facility === facilityName);
    const product = facility?.products.find((p) => p.id === productId);
    if (product) {
      product.currentLevels[type] = value;
    }
    this.facilitiesChange.emit(updated);
  }

  getMax(product: ProductWithLevels, type: keyof ProductCurrentLevels): number {
    return product.maxLevels[type] ?? 0;
  }
}
